var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"query-result-container"},[_c('a-layout',[_c('a-layout-header',[_c('header-action')],1),_c('a-layout',[_c('a-layout-sider',[_c('sider-form')],1),_c('a-layout-content',[_c('content-list',{attrs:{"is-admin":_vm.isAdmin}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }